
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corsoadozionale",
      function () {
        return require("private-next-pages/corsoadozionale/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corsoadozionale"])
      });
    }
  